import { Column } from 'primereact/column';
import { DataTable, SortOrder } from 'primereact/datatable';
import React, { useEffect, useRef, useState } from 'react';
import westImg from 'src/assets/img/westImg.png';
import fsImg from 'src/assets/img/fsImg.png';
import logImg from 'src/assets/img/logImg.png';
import lianiImg from 'src/assets/img/lianiImg.png';
import { TiFlash } from 'react-icons/ti';
import { FaCircleExclamation } from 'react-icons/fa6';
import { convertedHoursMinutes, getRemovetzTime } from 'src/utils/function';
import { Tooltip } from 'flowbite-react';
import { BsDot } from 'react-icons/bs';
import { jobStatus } from 'src/constants/general';
import { Paginator } from 'primereact/paginator';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';

const MonthlyJobs = ({ modalOpenMonthlyJobs, monthlyJobsData, getMonthlyJobs, isLoading }: any) => {
    const [first, setFirst] = useState(0);
    const [page, setPage] = useState(0);
    const [selectedValue, setSelectedValue] = useState('all');
    const options = [
        { name: 'All Jobs', value: 'all' },
        { name: 'Weekend Jobs', value: 'weekend' },
    ];
    const [sortField, setSortField] = useState<string>('totalHours');
    const [sortOrder, setSortOrder] = useState<SortOrder>(-1);
    const isFirstRender = useRef(true);

    const onSort = (e: any) => {
        setSortField(e.sortField);
        setSortOrder(e.sortOrder);
        setPage(0);
        setFirst(0);
    };
    const Getcomp = (row: any) => (
        <div className="flex items-center gap-1">
            <img className="w-6 h-6 rounded-full" src={row.companyName === 'West' ? westImg : row.companyName === 'Log' ? logImg : row.companyName === 'Liani' ? lianiImg : fsImg} alt="img" />
            <div className="text-black text-xs font-medium font-['Satoshi Variable'] uppercase">{row.companyName}</div>
        </div>
    );
    const Getjobtype = (row: any) => (
        <div className="flex items-center">
            <div className="flex items-center gap-0 relative">
                {row.isAsap ? (
                    <span className="w-5 h-5 rounded-full bg-red-50 text-red500 flex justify-center items-center mr-1 absolute left-[-25px]">
                        <TiFlash />
                    </span>
                ) : (
                    ''
                )}
                {row.isMandatory ? (
                    <span className={`iconresponsive w-5 h-5 rounded-full bg-white text-blue-800 flex justify-center items-center mr-1 absolute ${row.isAsap ? 'left-[-50px]' : 'left-[-25px]'}`}>
                        <FaCircleExclamation size={30} />
                    </span>
                ) : (
                    ''
                )}
            </div>
            <div className="text-black text-xs font-medium font-['Satoshi Variable'] uppercase">{row.jobType}</div>
        </div>
    );
    const GetStartDate = (row: any) => getRemovetzTime(row.startDate, 'MMM. DD, YY');

    const GetEndDate = (row: any) => {
        if (row.endDate) {
            return getRemovetzTime(row.endDate, 'MMM. DD, YY');
        } else {
            return (
                <div className="">
                    <p className="px-5">-</p>
                </div>
            );
        }
    };
    const Getassignemply = (row: any) => {
        const employee = () => (
            <div>
                {row.employeeList.map((data: any, index: number) => (
                    <p className="truncate" key={index}>{`${data.name} ${data.surname}`}</p>
                ))}
            </div>
        );

        return row?.employeeList?.length === 1 ? (
            <p className="truncate">{`${row.employeeList[0].name} ${row.employeeList[0].surname}`}</p>
        ) : (
            <div className="flex">
                <p className="truncate me-[6px]">{`${row.employeeList[0].name} ${row.employeeList[0].surname}..`}</p>
                <Tooltip className="bg-black text-white" content={<>{employee()}</>}>
                    <div className="w-4 h-4 px-2 pt-0.5 pb-1 bg-indigo-500 rounded-2xl flex-col justify-center items-center gap-2 inline-flex">
                        <div className="text-white text-xs font-medium font-['Satoshi Variable']">{row?.employeeList?.length}</div>
                    </div>
                </Tooltip>
            </div>
        );
    };
    const Getstatus = (row: any) => {
        const statusColors: any = {
            [jobStatus.complete]: 'bg-Green20 text-Green80',
            [jobStatus.cancel]: 'bg-purpleLight text-purple80',
            [jobStatus.fail]: 'bg-red20 text-red500',
            [jobStatus.inprogress]: 'bg-yellow20 text-yellow80',
            [jobStatus.invoiced]: 'bg-secondary20 text-secondary',
        };

        const isColor = statusColors[row.status] || '';
        return (
            <div className={`h-6 pe-2 min-w-24 py-1 ${isColor} rounded-lg justify-center items-center inline-flex`}>
                <div>
                    <BsDot size={18} />
                </div>
                <div className={`text-xs font-medium`}>{row.status}</div>
            </div>
        );
    };

    const getTotalHours = (row: any) => <span>{convertedHoursMinutes(row.totalHours, ':')}</span>;

    const getJobsData = () => {
        const url = `?page=${page + 1}&limit=10&status=done&jobType=${monthlyJobsData.jobTypeId}&startDate=${monthlyJobsData.startDate}&endDate=${monthlyJobsData.endDate}&weekendOnly=${
            selectedValue === 'weekend' ? 1 : 0
        }&sortHour=${sortOrder}
        `;
        getMonthlyJobs(url, monthlyJobsData.startDate, monthlyJobsData.endDate, monthlyJobsData.jobTypeId);
    };
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        getJobsData();
    }, [page, sortOrder]);

    const onPageChange = (event: any) => {
        setFirst(event.first);
        setPage(event.page);
    };

    const handleChange = (e: any) => {
        const url = `?page=1&limit=10&status=done&startDate=${monthlyJobsData.startDate}&endDate=${monthlyJobsData.endDate}&weekendOnly=${e.value === 'weekend' ? 1 : 0}`;
        getMonthlyJobs(url, monthlyJobsData.startDate, monthlyJobsData.endDate);
        setSelectedValue(e.value);
        setPage(0);
        setFirst(0);
    };

    return (
        <div className="pt-4 min-w-[1270px] max-lg:max-w-96">
            <div className="text-center text-zinc-800 text-lg font-medium font-['Satoshi Variable']">{modalOpenMonthlyJobs}</div>
            <div className="w-full flex justify-end">
                <Dropdown value={selectedValue} onChange={handleChange} options={options} optionLabel="name" className="w-48 border" />
            </div>
            <div className={`${modalOpenMonthlyJobs === 'Monthly Jobs list' ? 'h-[calc(100vh-150px)]' : ''} scrollbar-hide overflow-y-auto`}>
                {isLoading ? (
                    <div className="card w-full h-[750px] flex justify-content-center items-center ">
                        <ProgressSpinner />
                    </div>
                ) : (
                    <>
                        <DataTable
                            value={monthlyJobsData.jobs}
                            tableClassName="logdatatable jobdatatable"
                            emptyMessage="No Job Record Found"
                            className=""
                            lazy
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={onSort}
                        >
                            <Column field="comp" header="Comp." body={Getcomp}></Column>
                            <Column field="jobtype" header="Job type" body={Getjobtype}></Column>
                            <Column field="jobConfirmation" header="Job ID"></Column>
                            <Column field="assignemply" header="Assigned Employee" body={Getassignemply}></Column>
                            <Column field="requestorName" header="Requestor Name"></Column>
                            <Column field="startdate" header="Start Date" body={GetStartDate}></Column>
                            <Column field="enddate" header="End Date" body={GetEndDate}></Column>
                            <Column field="departmentName" header="Department"></Column>
                            <Column field="totalHours" header="Job Hours" body={getTotalHours} sortable></Column>
                            <Column field="status" header="Status" body={Getstatus}></Column>
                        </DataTable>
                    </>
                )}
                <Paginator
                    first={first}
                    rows={10}
                    totalRecords={monthlyJobsData.total}
                    onPageChange={onPageChange}
                    className="datatable_pagination datatable_pagination_joblist"
                    template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                />
            </div>
        </div>
    );
};

export default MonthlyJobs;
